<template>
  <el-menu :collapse="isCollapsed" :collapse-transition="false">
    <el-menu-item-group :title="$t('navGroupHeadlineBluebox')">
      <el-menu-item
        v-for="item in items"
        :key="item.name"
        :class="{ 'is-active--custom': $route.path.includes(item.name) }"
        @click="$router.push({ path: '/connect/' + item.name })"
      >
        <span slot="title">{{ item.title }}</span>
        <i v-if="item.icon && item.icon.length" class="material-icons m-r-1">{{ item.icon }}</i>
      </el-menu-item>
    </el-menu-item-group>
  </el-menu>
</template>

<script>
export default {
  name: 'AppNavigationConnect',

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  computed: {
    isCollapsed() {
      return this.$store.state.menu.collapse;
    }
  }
};
</script>
